import React from 'react';
import { Edit, Trash2, Eye, CheckCircle, X, Ban } from 'lucide-react';

const CandidatActions = ({
  candidat,
  onChangeStatut,
  onOpenDetailsModal,
  onOpenModal,
  onOpenDeleteModal
}) => {
  return (
    <div className="flex items-center justify-end space-x-2">
      {/* Actions de statut */}
      {candidat.statut_inscription === 'BROUILLON' && (
        <button
          onClick={() => onChangeStatut(candidat.id, 'CONFIRME')}
          className="text-green-600 hover:text-green-900 p-1 rounded-full hover:bg-green-50 transition-colors"
          title="Confirmer"
        >
          <CheckCircle className="h-4 w-4" />
        </button>
      )}
      
      {(candidat.statut_inscription === 'BROUILLON' || candidat.statut_inscription === 'SOUMIS') && (
        <button
          onClick={() => onChangeStatut(candidat.id, 'REJETE')}
          className="text-red-600 hover:text-red-900 p-1 rounded-full hover:bg-red-50 transition-colors"
          title="Rejeter"
        >
          <X className="h-4 w-4" />
        </button>
      )}
      
      {candidat.statut_inscription !== 'ANNULE' && (
        <button
          onClick={() => onChangeStatut(candidat.id, 'ANNULE')}
          className="text-orange-600 hover:text-orange-900 p-1 rounded-full hover:bg-orange-50 transition-colors"
          title="Annuler"
        >
          <Ban className="h-4 w-4" />
        </button>
      )}
      
      {/* Actions générales */}
      <button
        onClick={() => onOpenDetailsModal(candidat)}
        className="text-blue-600 hover:text-blue-900 p-1 rounded-full hover:bg-blue-50 transition-colors"
        title="Voir détails"
      >
        <Eye className="h-4 w-4" />
      </button>
      <button
        onClick={() => onOpenModal(candidat)}
        className="text-indigo-600 hover:text-indigo-900 p-1 rounded-full hover:bg-indigo-50 transition-colors"
        title="Modifier"
      >
        <Edit className="h-4 w-4" />
      </button>
      <button
        onClick={() => onOpenDeleteModal(candidat)}
        className="text-red-600 hover:text-red-900 p-1 rounded-full hover:bg-red-50 transition-colors"
        title="Supprimer"
      >
        <Trash2 className="h-4 w-4" />
      </button>
    </div>
  );
};

export default CandidatActions; 